/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Элемент списка пользовательских регистров (портфеля)
 * @export
 * @interface RegistryItem
 */
export interface RegistryItem {
  /**
   * Путь реестра: <scope>-<база><номер>
   * @type {string}
   * @memberof RegistryItem
   */
  path: string
  /**
   * Ссылка на изображение знака
   * @type {string}
   * @memberof RegistryItem
   */
  imageUrl: string
  /**
   * Номер свидетельства
   * @type {string}
   * @memberof RegistryItem
   */
  number: string
  /**
   * Тип свидетельства (секция реестра)
   * @type {string}
   * @memberof RegistryItem
   */
  section: string
  /**
   * Код базы реестра
   * @type {string}
   * @memberof RegistryItem
   */
  code: string
  /**
   * Код страны регистрационного ведомства
   * @type {string}
   * @memberof RegistryItem
   */
  country?: string | null
  /**
   * Дата истечения свидетельства
   * @type {Date}
   * @memberof RegistryItem
   */
  expiryDate?: Date | null
  /**
   * Наименование владельца товарного знака с кратким ОПФ
   * @type {string}
   * @memberof RegistryItem
   */
  rightHolder?: string | null
}

/**
 * Check if a given object implements the RegistryItem interface.
 */
export function instanceOfRegistryItem(value: object): value is RegistryItem {
  if (!('path' in value) || value['path'] === undefined) return false
  if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false
  if (!('number' in value) || value['number'] === undefined) return false
  if (!('section' in value) || value['section'] === undefined) return false
  if (!('code' in value) || value['code'] === undefined) return false
  return true
}

export function RegistryItemFromJSON(json: any): RegistryItem {
  return RegistryItemFromJSONTyped(json, false)
}

export function RegistryItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryItem {
  if (json == null) {
    return json
  }
  return {
    path: json['path'],
    imageUrl: json['imageUrl'],
    number: json['number'],
    section: json['section'],
    code: json['code'],
    country: json['country'] == null ? undefined : json['country'],
    expiryDate:
      json['expiryDate'] == null ? undefined : new Date(json['expiryDate']),
    rightHolder: json['rightHolder'] == null ? undefined : json['rightHolder'],
  }
}

export function RegistryItemToJSON(value?: RegistryItem | null): any {
  if (value == null) {
    return value
  }
  return {
    path: value['path'],
    imageUrl: value['imageUrl'],
    number: value['number'],
    section: value['section'],
    code: value['code'],
    country: value['country'],
    expiryDate:
      value['expiryDate'] == null
        ? undefined
        : (value['expiryDate'] as any).toISOString(),
    rightHolder: value['rightHolder'],
  }
}
